export class CommonResponse<T> {

  status: string;
  message: string;
  error: string;

  data: T;
}

export let lastMessage: string;

export function processNormal(data) {

  if (data.status === 'ERROR') {
    throw new Error(data.message);
  }

  lastMessage = data.message;

  return data.data;
}

export class VoidResponse {
  extra_data: string;
}

export class CommonPaginationResponse<T> {
  status: string;
  message: string;
  error: string;
  pagination: PaginateResponse<T>;
}

export function processPagination(data) {
  if (data.status === 'ERROR') {
    throw new Error(data.message);
  }

  return data.pagination;
}

export class PaginateResponse<T> {
  current_page = 1;
  data: T;
  first_page_url: string;
  from: number;
  last_page = 1;
  last_page_url: string;
  links: PaginateLinks[];
  next_page_url: string;
  path: string;
  per_page = 100;
  prev_page_url: string;
  to: number;
  total = 1;
  loading = true;

  constructor(valueForData?) {
    this.data = valueForData;
  }
}

export class PaginateLinks {
  url: string;
  label: string;
  active: boolean;
}
